import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/sections/Footer';
import { SEO } from '@/components/SEO';
import { useTranslation } from 'react-i18next';

const Prenota = () => {
  const { t } = useTranslation(['prenota', 'seo']);

  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title={t('seo:prenota.title')}
        description={t('seo:prenota.description')}
        keywords={t('seo:prenota.keywords')}
        logicalPath="/prenota"
      />
      <Header />
      <section className="py-32 px-6">
        <div className="mx-auto max-w-4xl">
          <div className="mb-8 text-center">
            <h1 className="mb-4 text-4xl font-semibold text-foreground md:text-5xl">{t('prenota:title')}</h1>
            <p className="text-muted-foreground">{t('prenota:subtitle')}</p>
          </div>
          <div className="relative w-full overflow-hidden rounded-lg border border-border bg-card">
            <iframe
              src="https://rgradcpiwm98zpetuigzzghomf3fmzoq.forms.pienissimo.pro/?id=Fl7E3J"
              className="h-[1500px] md:h-[1500px] w-full border-0"
              title={t('prenota:iframeTitle')}
              allow="clipboard-write"
              loading="lazy"
            />
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default Prenota;
